import { DownOutlined } from "@ant-design/icons";
import { Collapse, Typography } from "antd";
import React, { FC } from "react";
import { JCollapse } from "../JCollapse";
import "./JAccordion.scss";

const {
    Title,
} = Typography

const { Panel } = Collapse
export interface JAccordionItem {
    title: string,
    content: JSX.Element
}
export interface JAccordionProps {
    items: JAccordionItem[]
}

export const JAccordion: FC<JAccordionProps> = (props) => {
    return (

        <JCollapse
            className="jaccordion"
            expandIcon={(acc: any) =>
                <DownOutlined aria-hidden={true} className="secondIcon" rotate={acc?.isActive ? 0 : 180} />
            }
            expandIconPosition="end"
            ghost
        >
            {
                props.items.map((item, i) => (
                    <Panel header={<Title className='jaccordion-title' level={4}>{item.title}</Title>} key={i}>
                        {item.content}
                    </Panel>
                ))
            }

        </JCollapse>
    )
}
